import '../../httpservices/core/ajax.httpservice.core';

class ImmunizationConsentFormHttpService {

    //model = ImmunizationConsentFormModel.cs
    SubmitToPreview(model) {
        return $.post('Patient/ImmunizationConsent/SubmitToPreview', model);
    }

    //model = ImmunizationConsentFormModel.cs
    SubmitForm(model) {
        return $.post('Patient/ImmunizationConsent/SubmitForm', model);
    }

    PageInit() {
        return $.get('Patient/ImmunizationConsent/PageInit');
    }
}

export const ImmunizationConsentFormHttpSvc = new ImmunizationConsentFormHttpService();